/**
 * @description properties of editor's active state
 * @property previewDeviceMode - property containing information about the active mode of the preview ({@link PreviewDeviceMode})
 */
export enum EditorStatePropertyType {
  previewDeviceMode = 'previewDeviceMode',
  panelPosition = 'panelPosition',
  themeMode = 'themeMode',
}
